import React from "react";
import HomePageHeader from "./Header/HomePageHeader";

const HomePage: React.FC = () => {
  return (
    <div>
      <HomePageHeader />
    </div>
  );
};

export default HomePage;
